'use strict';

import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {ConfigService} from "@cosbeni/auth";

import {Observable} from 'rxjs';


@Injectable()
export class DatabaseService {

    constructor(private http: HttpClient,private config: ConfigService) {
    }

    get(database: string, url?: string): Observable<any> {
        let requestURL = url + "/database/" + database;
        this.config.setTokenPrefix(database);
        return this.http.get(requestURL);
    }

    list(url?: string) {
        let requestURL = url + "/listDatabases";
        return this.http.get(requestURL);
    }

    command(params: any, url?: string): Observable<any> {
        let startTime = new Date().getTime();
        let limit = params.limit || 100;
        let verbose = params.verbose != undefined ? params.verbose : true;
        let shallow = '';
        let contentType = params.contentType || 'application/json';
        let requestURL = url + "/command/" + params.database + "/" + params.language + "/-/" + limit + "?format=rid,type,version" + shallow + ",class,graph";
        return this.http.post(requestURL, params.text.trim(), {headers: new HttpHeaders().set('Content-Type', contentType)});
    }

}



